import { render, staticRenderFns } from "./MemberRegistrationForm.vue?vue&type=template&id=96f058b4&scoped=true"
import script from "./MemberRegistrationForm.vue?vue&type=script&lang=ts"
export * from "./MemberRegistrationForm.vue?vue&type=script&lang=ts"
import style0 from "./MemberRegistrationForm.vue?vue&type=style&index=0&id=96f058b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f058b4",
  null
  
)

export default component.exports